import React from 'react';
import { DatePicker, Button } from 'antd';
import { PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

/**
 * Controlled list of date pickers - antd 4 DatePicker can't pick multiple dates.
 * Value is an array of dates; empty slots are kept as null until the user fills them.
 */
const MultiDatePicker = ({ value, onChange, placeholder }) => {
  const { t } = useTranslation();
  const dates = value?.length ? value : [null];

  const update = (next) => onChange?.(next);

  return (
    <div>
      {dates.map((date, idx) => (
        <div key={idx} style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
          <DatePicker
            style={{ flex: 1 }}
            value={date}
            placeholder={placeholder}
            onChange={(newDate) => update(dates.map((d, i) => (i === idx ? newDate : d)))}
          />
          {dates.length > 1 && (
            <MinusCircleOutlined
              style={{ marginLeft: 8, color: '#999' }}
              onClick={() => update(dates.filter((_, i) => i !== idx))}
            />
          )}
        </div>
      ))}
      <Button
        type="link"
        size="small"
        icon={<PlusOutlined />}
        style={{ padding: 0 }}
        onClick={() => update([...dates, null])}
      >
        {t('clientInform.addDate')}
      </Button>
    </div>
  );
};

export default MultiDatePicker;
